import type { ReactNode } from "react";
import { FormValidationSubmittedProvider } from "./Internal/FormValidationContext";

/**
 * Renders children as if their form had been submitted, so FormItem errors
 * (and control error borders) display immediately. Errors normally appear
 * only after a field is blurred or a save is attempted — wrap stories and
 * tests that showcase error states in this. Works around bare FormItems and
 * around whole Form dialogs (Form ORs its own submitted state with this).
 *
 * `show` gates the effect (default `true`). Keep this component mounted and
 * toggle `show` rather than conditionally rendering it — mounting/unmounting
 * changes the child's element-position type and remounts the subtree, which
 * resets stateful children like Stripe card iframes. `show={false}` is a
 * no-op (errors still appear on blur via each field's touched state).
 */
export function ShowFormErrors({
  children,
  show = true,
}: {
  children: ReactNode;
  show?: boolean;
}) {
  return (
    <FormValidationSubmittedProvider value={show}>
      {children}
    </FormValidationSubmittedProvider>
  );
}
